import { Typography } from "@mui/material"

const Dashboard = () => {
    return (
        <Typography variant="h1">Welcome</Typography>
    )
}

export default Dashboard